import React, { useEffect} from "react";
import Freeship from "./freeship";
import Sameday from "./sameday";
import Pickupconfig from "./pickupconfig";
import { useNavigate } from "react-router-dom";

const Home = () => {
    const navigate = useNavigate();
    useEffect(() => {
        const token = localStorage.getItem('token');
        if(!token) {
            navigate("/login");
        }
    }, [navigate]);
    return (
        <div>
            <h1>Hello Admin, Welcome!</h1>
            <p>Configure your OzWashroom website's Shipping criteria.</p>
            <Freeship />
            <Sameday />
            <Pickupconfig />
        </div>
    );
};
 
export default Home;